module.exports = __webpack_public_path__ + "static/media/245.0026af4f.wav";